import { paths } from '@/routes/paths';
import { GlobalStateProvider } from '@/common/hooks/useGlobalState';

export const saveLastVisitedPage = () => {
  const { pathname, search } = window.location;

  if (pathname.includes(paths('token'))) {
    return;
  }

  GlobalStateProvider.current().set({ lastVisitedPage: `${pathname}${search}` });
};
